import { useSelector } from 'react-redux'
import { useI18n } from 'builder/hooks/useI18n'
import {
  DownloadDocumentHandler,
  selectors as resumeEditorSelectors,
} from 'builder/modules/resumeEditor'
import { selectors as renderingSelectors } from 'builder/modules/rendering'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { DownloadButton } from 'builder/components/PreviewPanel'
import { StartTailoringButton } from 'builder/components/DocumentEditor/TailoringFromPublicJobBoard'
import { FORMATS } from 'builder/modules/constants'
import { ToolbarRight as Container, Updating, UpdatingIcon, UpdatingText } from '../../styles'

interface ToolbarRightProps {
  handleDownloadDocument: DownloadDocumentHandler
  isSyncing: boolean
  handleShareDocument?: () => void
  handleCombineDocuments?: () => void
  handleDownloadButtonMenuOpen?: () => void
  showResumeDistributionModal?: (format: FORMATS) => void
}

const ToolbarRight = (props: ToolbarRightProps) => {
  const {
    handleDownloadDocument,
    isSyncing,
    handleShareDocument,
    handleDownloadButtonMenuOpen,
    showResumeDistributionModal,
  } = props
  const { i18n } = useI18n()

  const isDownloading = useSelector(renderingSelectors.isDocumentDownloading)
  const isPreviewGenerating = useSelector(renderingSelectors.isPreviewGenerating)
  const isUpdating = isSyncing || isPreviewGenerating

  const autoTailoringFromPublicJobBoard = useTypedSelector(
    resumeEditorSelectors.autoTailoringFromPublicJobBoard,
  )

  return (
    <Container>
      <Updating isVisible={isUpdating}>
        <UpdatingIcon />
        <UpdatingText>{i18n.t('builder.resume_editor.updating')}</UpdatingText>
      </Updating>

      {autoTailoringFromPublicJobBoard.enabled ? (
        <StartTailoringButton />
      ) : (
        <DownloadButton
          handleDownloadDocument={handleDownloadDocument}
          handleShareDocument={handleShareDocument}
          handleDownloadButtonMenuOpen={handleDownloadButtonMenuOpen}
          showResumeDistributionModal={showResumeDistributionModal}
          isDownloading={isDownloading}
        />
      )}
    </Container>
  )
}

export default ToolbarRight
